<template>
    <div class="row">
        <b-card no-body class="col-12">
            <span>Usuários que estão aguardando aprovação ou que foram aprovados/reprovados</span>
            <div class="dropdown-divider"></div>
            <b-form-checkbox v-model="status" name="check-button" switch @change="updateList">
                <b>Somente status aguardando</b>
            </b-form-checkbox>
        </b-card>
        <b-card no-body class="mt-3 col-12">
            <b-tabela @doisClicksLinha="editar" :colunas="table.fields" :dados="table.items">
                <template #cell(status)="data">
                    <b-badge :variant="`${getColors(data.item.item.status)}`">
                        {{data.item.item.status}}
                    </b-badge>
                </template>
                <template #cell(actions)="data">
                    <div class="d-flex">
                        <b-button variant="flat-primary" v-if="data.item.item.status =='Aguardando' && permissao.r" @click="editar(data.item.item)">
                            <i class="fas fa-edit"></i>
                        </b-button>
                    </div>
                </template>
            </b-tabela>

        </b-card>
    </div>
</template>
<script>

import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";
import AprovacaoService from "@/common/services/usuario/aprovacao.service";
import { START_LOADING, STOP_LOADING } from "@/store/Store";

import helpers from "@/common/utils/helpers";
export default {
    
    data : () => ({
        status : true,
        items : [],
        table: {
            fields : [
                {key: "actions", label: "Ações"},
                {key: "nome", label: "Nome" },
                {key: "cpf", label: "CPF" ,
                    formatter: (value) => {
                        if (value) return helpers.formatarCPF(value, true);
                    },
                },
                {key: "nomeUsuario", label: "Login" },
                {key: "email", label: "E-mail" },
                {key: "dataCriacao", label: "Data de registro" ,
                    formatter: (value) => {
                        if (value) return helpers.formatarDataBr(value, true);
                    },
                },
                {key: "status", label: "Status" },
            ],
            items : [],
            perPage : 0,
            currentPage: 1,
            dataLength : 0,
        }
    }),
    mounted() {
        this.$store.dispatch(DEFINIR_BREADCRUMB, [
            { titulo: this.$t("MENU.APROVACAO_USUARIOS") }
        ]);

        this.getList('Aguardando', 0);
    },
    methods : {
        getColors : function(status){
            switch(status){
                case 'Aguardando':
                    return 'info';
                case 'Aprovado':
                    return 'success';
                case 'Reprovado':
                    return 'danger';
            }
        },
        getList : function(status,  pagina){
            this.$store.dispatch(START_LOADING);
            
            AprovacaoService.listar(status, this.table.perPage , pagina).then(response => {
                this.table.items = response.data.data.itens;
                this.table.dataLength = response.data.data.paginacao.totalDeElementos;
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });
        },
        editar : function(item){ 
            if(this.permissao.r)
            this.$router.push({ name: "aprovacao-usuario-formulario", params: { usuario : item } });
        },
        updatePagination : function(page){
            this.getList(this.status ? 'Aguardando' : '',page - 1);
        },
        updateList : function(){
            this.table.currentPage = 1
            this.getList(this.status ? 'Aguardando' : '', 0);
        },
    },
    computed : {
        permissao() {
            return this.$store.getters['app/retornaPermissao']('AprovacaoUsuario');
        },
    }
}
</script>
<style>
    .card {
        min-height: inherit !important;
    }
</style>